import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "checkbox", "card", "submit"]

  connect() {
    this.update()
  }

  update() {
    this.checkboxTargets.forEach((checkbox, index) => {
      this.cardTargets[index]?.classList.toggle("lead-generation-channel--selected", checkbox.checked)
    })

    const hasName = this.nameTarget.value.trim().length >= 3
    const hasChannel = this.checkboxTargets.some(checkbox => checkbox.checked)
    this.submitTarget.disabled = !(hasName && hasChannel)
  }
}
